import { MDXEditor } from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import Grid from '@mui/material/Grid2'
import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { SHORT_PLUGINS } from '../../../../constants/plata'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'

export const Memo = () => {
    const [searchParams] = useSearchParams()
    const id = searchParams.get('id')
    const { fetchMemoShare, memoPublic } = useAssistantAdministrationStore((state) => state)

    useEffect(() => {
        if (id) {
            fetchMemoShare({ memoId: id })
        }
    }, [])

    return (
        <Grid size={12}>
            <div
                style={{
                    height: `calc(100dvh - ${164}px)`,
                    overflowY: 'auto',
                }}>
                {memoPublic && (
                    <>
                        <MDXEditor markdown={memoPublic.content} plugins={SHORT_PLUGINS} />
                    </>
                )}
            </div>
        </Grid>
    )
}
